import PendoIcon from '../../icon/pendo-icon.vue.js';
import PendoMultiselect from '../../multiselect/pendo-multiselect.vue.js';
import PendoDraggable from '../../../directives/draggable/pendo-draggable.js';
import PendoTooltip from '../../../directives/tooltip/pendo-tooltip.js';
import cloneDeep from 'lodash/cloneDeep.js';

var script = {
  name: 'PendoColumnReorder',
  components: {
    PendoIcon,
    PendoMultiselect
  },
  directives: {
    PendoDraggable,
    PendoTooltip
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    availableColumns: {
      type: Array,
      default: () => []
    },
    disableFirst: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    valueKey: {
      type: String,
      default: 'prop'
    },
    labelKey: {
      type: String,
      default: 'label'
    },
    placeholder: {
      type: String,
      default: 'Select column'
    },
    addButtonLabel: {
      type: String,
      default: 'Add column'
    },
    allSelectedText: {
      type: String,
      default: 'All available columns selected.'
    }
  },
  data() {
    return {
      allColumnsSelected: false
    };
  },
  computed: {
    disableAddColumn() {
      if (this.$slots.multiselect || this.$scopedSlots.multiselect) {
        return false;
      }
      return this.disabled || this.allColumnsSelected || this.value.length === this.availableColumns.length;
    }
  },
  methods: {
    updateColumnIndex(_ref) {
      let {
        newIndex,
        oldIndex
      } = _ref;
      if (newIndex !== oldIndex) {
        const columns = this.value.slice(0);
        columns.splice(newIndex, 0, ...columns.splice(oldIndex, 1));
        this.handleColumnsChange(columns);
      }
    },
    handleColumnSelect(column, index) {
      const columns = cloneDeep(this.value);
      columns.splice(index, 1, column);
      this.handleColumnsChange(columns);
    },
    handleAllColumnsSelected(value) {
      this.allColumnsSelected = value;
    },
    handleColumnsChange(columns) {
      this.$emit('columns-change', columns);
    },
    addColumn() {
      if (this.disableAddColumn) {
        return;
      }
      const columns = [...this.value, {}];
      this.handleColumnsChange(columns);
    },
    removeColumn(column, index) {
      if (index === 0 && this.disableFirst) {
        return;
      }
      const columns = this.value.slice(0, index).concat(this.value.slice(index + 1));
      this.handleColumnsChange(columns);
    },
    isColumnDisabled(column, index) {
      return index === 0 && this.disableFirst || this.disabled || column.disabled;
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-column-reorder.vue2.js.map
